import React, { useState } from "react";
import { Row, Col, Button, Form, Input } from "antd";
import { unAuthenticatedRoutes } from "../../routes/constant";
import AuthService from "../../services/auth.service";
import notificationService from "../../util/notification.service";
import utilService from "../../util/utils.service";
import resetPass from "../../assets/images/reset-pass.png";
import { useHistory } from "react-router-dom";

const FormItem = Form.Item;

const ResetPassword = (props) => {
    const [loading, setLoading] = useState(false);

    const history = useHistory();
    const onFinish = async (values) => {
        setLoading(true);
        const { ok } = await AuthService.resetPassword({
            email: history?.location?.state.email,
            password: values.password,
            confirmPassword: values.confirmPassword,
            otp: +history?.location?.state.otp,
        });
        if (ok) {
            notificationService.info(`Password Changed!`);
            setTimeout(() => {
                return utilService.redirectTo(unAuthenticatedRoutes.LOGIN);
            }, 3000);
        } else {
            notificationService.error("Invalid Password!");
        }
        setLoading(false);
    };

    return (
        <div className="auth-background gx-app-login-wrap reset-pass-main">
            <div className="gx-app-login-container">
                <Row gutter={[0, 25]} type="flex">
                    <Col span={24} align="middle" justify="center">
                        <div className="gx-app-logo">
                            <img src={resetPass} alt="Logo" />
                            <h2>Create New Password</h2>
                            <p>
                                You can now enter and confirm your new password
                            </p>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div className="gx-app-login-main-content">
                            <div className="gx-app-login-content">
                                <Form
                                    initialValues={{ remember: true }}
                                    name="basic"
                                    onFinish={onFinish}
                                    className="gx-signin-form gx-form-row0"
                                >
                                    <Form.Item
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input your password!",
                                            },
                                        ]}
                                        hasFeedback
                                    >
                                        <Input.Password
                                            className="inpt"
                                            placeholder="Password"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="confirmPassword"
                                        dependencies={["password"]}
                                        hasFeedback
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please confirm your password!",
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (
                                                        !value ||
                                                        getFieldValue(
                                                            "password"
                                                        ) === value
                                                    ) {
                                                        return Promise.resolve();
                                                    }

                                                    return Promise.reject(
                                                        new Error(
                                                            "The two passwords that you entered do not match!"
                                                        )
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password
                                            className="inpt"
                                            placeholder="Confirm Password"
                                        />
                                    </Form.Item>

                                    <FormItem>
                                        <Button
                                            type="primary"
                                            className="gx-mb-0 butn"
                                            htmlType="submit"
                                            loading={loading}
                                        >
                                            Reset Password
                                        </Button>
                                    </FormItem>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default ResetPassword;
